var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 80,
    viewBox: "20 8 120 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 31,
    width: 79,
    height: 34,
    fill: "#3A7341",
    stroke: "#56AD61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 80,
    cy: 48,
    r: 12,
    fill: "#56AD61"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.9202,
    y: 27.0952,
    width: 79,
    height: 34,
    transform: "rotate(5.8 41.9202 27.0952)",
    fill: "#3A7341",
    stroke: "#56AD61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 79.9974,
    cy: 48.0504,
    r: 12,
    transform: "rotate(5.8 79.9974 48.0504)",
    fill: "#56AD61"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.0152,
    y: 22.3088,
    width: 79,
    height: 34,
    transform: "rotate(13.4 45.0152 22.3088)",
    fill: "#3A7341",
    stroke: "#56AD61",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 79.9866,
    cy: 48.1159,
    r: 12,
    transform: "rotate(13.4 79.9866 48.1159)",
    fill: "#56AD61"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.7cad018f471e69a17f23a83deab48364.svg";
export { ForwardRef as ReactComponent };